/*******************************************************************************
//
//
//
//  #VIDEO
//
//
//
*******************************************************************************/

var Video = (function() {
    var _pause = function(element) {
        var $iframe = $(element).find('iframe');
        var $video = $(element).find('video');

        if($iframe.length) {
            var player = new Vimeo.Player($iframe);
    
            player.pause();
        }

        if($video.length) {
            $video[0].pause();
        }
    };

    var _play = function(element) {
        var $iframe = $(element).find('iframe');
        var $video = $(element).find('video');

        if($iframe.length) {
            var player = new Vimeo.Player($iframe);
    
            player.setMuted(true).then(function(muted) {
                if(muted === true) {
                    player.play();
                } else {
                    player.pause();
                }
            });
        }

        if($video.length) {
            for (var step = 0; step < $video.length; step++) {
                $video[step].muted = true;
                $video[step].play();
            }
        }
    };

    var _addEventListeners = function() {
        $('.c-video__cta').on('click', function(event) {
            event.preventDefault();

            var $this = $(this);
            var $component = $this.parent();
            var $iframe = $component.find('iframe');
            var player = new Vimeo.Player($iframe);

            player.play();
            
            player.on('play', function() {
                $this.hide();
            });
        });
    };

    var _init = function() {
        _addEventListeners();
    };

    return {
        pause: _pause,
        play: _play,
        init: _init
    };
})();